import React from "react";
import PropTypes from 'prop-types'
import FormComponent, { types } from '../Components/FormComponent'

export const formTypes = types;

class FormCreator extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      objectCreator: this.props.objectCreator
    }
    this._clear = false
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.objectCreator) !== JSON.stringify(this.props.objectCreator)) {
      this.initComponent()
      return
    }
    if (JSON.stringify(prevProps.values) !== JSON.stringify(this.props.values)) {
      const keys = Object.keys(this.props.values)
      const datos = keys.filter(k => JSON.stringify(this.props.values[k]) !== JSON.stringify(prevProps.values[k]))
      let object = this.state.objectCreator
      if (this._clear) {
        datos.forEach((dato, i) => {
          object = this.modificateObjectValue(dato, this.props.values[dato], object);
          object = this.handlerChangeVisible(dato, this.props.values[dato], object);
          this.setState({ [dato]: this.props.values[dato], objectCreator: object });
        })
      } else {
        datos.forEach(async (dato, i) => {
          object = this.modificateObjectValue(dato, this.props.values[dato], object);
          object = this.handlerChangeVisible(dato, this.props.values[dato], object);
          object = await this.handlerChangeCascade(dato, this.props.values[dato], object);
          this.setState({ [dato]: this.props.values[dato], objectCreator: object });
        })
      }

    }
  }

  initComponent = () => {
    if (this.props.values !== undefined) {
      const keys = Object.keys(this.props.values)
      let object = this.props.objectCreator
      keys.map(async (dato) => {
        object = this.modificateObjectValue(dato, this.props.values[dato], object)
        object = this.handlerChangeVisible(dato, this.props.values[dato], object)
        object = await this.handlerChangeCascade(dato, this.props.values[dato], object)
        this.setState({ [dato]: this.props.values[dato], objectCreator: object })
        return
      })
    }
  }

  componentDidMount() {
    this.initComponent()
  }

  handlerChange = async (dato, value, type = null) => {
    let setValue;
    if (type !== null && type === types.number) {
      setValue = value;
    } else if (types.checkbox === type) {
      const check = this.state.objectCreator.filter(item => item.variable === dato)[0];
      const values = check.value.filter(item => item !== value);
      if (!check.value.includes(value)) {
        values.push(value);
      }
      setValue = values;
    } else {
      setValue = value;
    }
    this.props.onChange(dato, setValue)
  };

  handlerClear = () => {
    const objectCreator = this.props.objectCreator.map(item => {
      if (item.type === types.select || item.type === types.checkbox) {
        this.props.onChange(item.variable, []);
        return { ...item, value: [] }
      } else if (item.type === types.radiobutton) {
        this.props.onChange(item.variable, null);
        return { ...item, value: null }
      } else if (item.type === types.question) {
        this.props.onChange(item.variable, false);
        return { ...item, value: false }
      } else {
        this.props.onChange(item.variable, "");
        return { ...item, value: "" }
      }
    });
    this.setState({ objectCreator })
  };

  modificateObjectValue = (variable, value, object) => {
    return object.map(item => {
      if (item.variable === variable)
        return { ...item, value }
      return { ...item }
    })
  }

  handlerChangeVisible = (variable, value, object) => {
    return object.map(item => {
      if (item.type === types.divContainer && item.visibleWith === variable) {
        if (item.visibleWhen === value)
          return { ...item, visible: true }
        if (item.visibleWhen.length === 1) {
          if (value.includes(item.visibleWhen[0]))
            return { ...item, visible: true }
        }
        return { ...item, visible: false }
      }
      return { ...item }
    })
  }

  handlerChangeCascade = async (variable, value, object) => {
    let objecsResult = []
    for (let i = 0; i < object.length; i++) {
      if (object[i].type === types.select && object[i].cascadeFrom === variable) {
        const result = await object[i].getData(value)
        objecsResult.push({ ...object[i], data: result })
      } else {
        objecsResult.push({ ...object[i] })
      }
    }
    return objecsResult
  };

  handlerSubmit = async () => {
    let object = this.state.objectCreator.map(item => this.handlerSubmitRecursivo(item))
    this.setState({ objectCreator: object })

    let flag = object.reduce((prev, curr) => (prev || !!curr.block || !!curr.notEmail || !!curr.notValidated), false)

    if (!flag) {
      const erase = await this.props.onSubmit()
      console.log('----erase')
      console.log(erase)
      if (erase) {
        this._clear = true
        this.handlerClear()
        this._clear = false
      }
    }
  }

  handlerSubmitRecursivo = item => {
    let add = { block: this.validateForm(item) }

    if (item.type === formTypes.email)
      add = { ...add, notEmail: this.validateMail(item.value) }

    if (item.equalTo !== undefined && item.equalTo !== null && item.equalTo.length > 0)
      add = { ...add, notValidated: this.validateEqualTo(item) }

    return { ...item, ...add }
  };

  validateForm = item => {
    if (item.required) {
      if (!(item.value !== undefined && item.value !== null)) {
        if (typeof item.value === 'object') {
          if (item.value.length > 0) return true
        } else { return true }
      } else {
        if (typeof item.value === "string") {
          if (item.value.trim() === "") return true
        }
      }
      return false
    } else {
      return false
    }
  }

  validateEqualTo = item => {
    return this.state.objectCreator.reduce((prev, curr) => {
      if (item.equalTo !== curr.variable) return prev
      return (prev || (curr.value !== item.value))
    }, false)
  }

  validateMail = mail => {
    let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
    return !emailRegex.test(mail);
  };

  render() {
    return (
      <FormComponent
        objectCreator={this.state.objectCreator}
        handlerChange={this.handlerChange}
        handlerSubmit={this.handlerSubmit}
      />
    );
  }
}

export default FormCreator;

FormCreator.propTypes = {
  onChange: PropTypes.func.isRequired,
  objectCreator: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSubmit: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired
};